import { render, staticRenderFns } from "./ListadoBorradores.vue?vue&type=template&id=81988e48&scoped=true"
import script from "./ListadoBorradores.vue?vue&type=script&lang=js"
export * from "./ListadoBorradores.vue?vue&type=script&lang=js"
import style0 from "./ListadoBorradores.vue?vue&type=style&index=0&id=81988e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81988e48",
  null
  
)

export default component.exports